import {useTransition} from '@yandex-delivery/blocks'
import {externalApiURL} from '@yandex-delivery/client-core/api/corp'
import type {ResponseHeaders, ServerError} from '@yandex-delivery/core/utils/network'
import type {Optional} from '@yandex-delivery/types'
import {addQuery} from '@yandex-delivery/utils'

import {fetch} from '../../../../../api/fetch'
import {useConfigContext} from '../../../../../contexts'
import type {AppConfig} from '../../../../../types'
import type {
  NddClaimOffersInfoQuery,
  OffersInfoList,
  OffersRequest,
  ResourcePlace,
  SourcePointDeliveryMethod,
} from '../types'
import {DestinationPointDeliveryMethod} from '../types'

export function fetchOffersInfoDeprecated(
  body: OffersRequest,
  query: NddClaimOffersInfoQuery,
  appConfig: AppConfig,
): Promise<{body: OffersInfoList; headers: ResponseHeaders}> {
  return fetch<OffersRequest, OffersInfoList, OffersInfoList>(appConfig, {
    url: addQuery(externalApiURL('platform/integration/v1/offers/info'), {...query, country: appConfig.countryCode}),
    method: 'post',
    body,
  })
}

type UseFetchOffersInfoHandlerProps = {
  sourcePointStationId?: string
  sourcePointDropOffPointId?: string
  sourcePointDeliveryMethod?: SourcePointDeliveryMethod
  destinationPointPickupPointId?: string
  places: ResourcePlace[]
  pointType: unknown
}

export function useFetchOffersInfo() {
  const [{payload: offersInfo, isPending: isOffersInfoPending}, startTransition] = useTransition<
    Optional<{body: OffersInfoList; headers: ResponseHeaders}>,
    ServerError
  >(undefined, {
    key: 'offers-info',
    shouldShowBaseError: false,
  })
  const appConfig = useConfigContext()

  function fetchOffersInfoHandler(props: UseFetchOffersInfoHandlerProps) {
    const {
      sourcePointDropOffPointId,
      sourcePointStationId,
      pointType,
      sourcePointDeliveryMethod,
      destinationPointPickupPointId,
      places,
    } = props

    startTransition(() => {
      if (sourcePointStationId === undefined && sourcePointDropOffPointId === undefined) {
        return Promise.resolve(undefined)
      }

      if (pointType === DestinationPointDeliveryMethod.PickUpPoint) {
        return Promise.resolve(undefined)
      }

      return fetchOffersInfoDeprecated(
        {
          source: {
            platform_station_id:
              sourcePointDeliveryMethod === 'station' ? sourcePointStationId : sourcePointDropOffPointId,
          },
          destination: {
            platform_station_id: destinationPointPickupPointId,
          },
          places,
        },
        {
          last_mile_policy: '',
        },
        appConfig,
      )
    })
  }

  return {
    isOffersInfoPending,
    offersInfo,
    fetchOffersInfoHandler,
  }
}
